import { FC, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import { SortBy } from "shared/components";
import { Spacer } from "shared/layout";
import { searchVenueSelector } from "Venues/state";
import { ISortingOptionKeys, IVenue } from "Venues/types";
import { useScrollIntoView } from "Venues/utils";
import { VenueSearchForm } from "Bands/components";
import { VenueSearchResults } from "Bands/containers";
import { IVenueSearchQuery, useVenueBlockContext, VenueBlockState } from "Bands/contexts";

interface VenueSearchProps {}

export const VenueSearch: FC<VenueSearchProps> = () => {
  const { setCurrentState, query, setQuery, setVenueId } = useVenueBlockContext();

  const venues: IVenue[] = useSelector(searchVenueSelector);

  const { ref, scrollIntoView } = useScrollIntoView();
  useEffect(() => {
    scrollIntoView(false, "auto");
  }, [query.page]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = (data: IVenueSearchQuery) => {
    setQuery({ ...query, ...data, page: 1 });
  };

  const handlePageChange = (page: number) => {
    setQuery({ ...query, page });
  };

  const handleSortChange = (sort: ISortingOptionKeys) => {
    setQuery({ ...query, sort, page: 1 });
  };

  const handleVenueClick = (venue: IVenue) => {
    setCurrentState(VenueBlockState.chooseVenue);
    setVenueId(venue.id);
  };

  const defaultValues = useMemo(
    () => ({
      query: query?.query,
      country: query?.country,
    }),
    [query]
  );

  const isSearched = useMemo(() => query.query || query.country, [query]);

  return (
    <>
      <VenueSearchForm handleSubmit={handleSearch} defaultValues={defaultValues} />
      <div ref={ref}>
        <Spacer size="m">
          {isSearched && !!venues.length && (
            <SortBy sort={query.sort} onSortChange={handleSortChange} />
          )}
          <VenueSearchResults
            venues={venues}
            query={query}
            handlePageChange={handlePageChange}
            handleVenueClick={handleVenueClick}
          />
        </Spacer>
      </div>
    </>
  );
};
